import GalerieStars from "./GalerieStars.js"

export default class StarsPostGallery {
    constructor(/** HTMLElement */ starsPostContainer) {
        this.starsPostContainer = starsPostContainer
        this.galleries = {}

        this.initializeGalleries()
    }

    initializeGalleries() {
        /** void */
        const starsPosts = this.findUninitializedPosts()

        for (const postGalleryContainer of starsPosts) {
            this.initGalleryForPost(postGalleryContainer)
        }
    }

    findUninitializedPosts() {
        /** NodeListOf<HTMLElement> */
        return this.starsPostContainer.querySelectorAll(".gallery-slider-container:not(.gallery-initialized)")
    }

    initGalleryForPost(/** HTMLElement */ postGalleryContainer) {
        /** void */
        document.body.appendChild(postGalleryContainer)

        const galleryId = postGalleryContainer.getAttribute("id")
        const galleryData = postGalleryContainer.querySelector('data[data-type="jsonData"]')

        let galleryConfig = JSON.parse(galleryData.getAttribute("value"))
        galleryConfig = this.appendInfoToGalleryConfig(galleryConfig)

        this.galleries[galleryId] = new GalerieStars(galleryConfig)

        postGalleryContainer.instance = this.galleries[galleryId]
        postGalleryContainer.classList.add("gallery-initialized")

        this.galleries[galleryId].init()
        $(document).trigger("init:gallery.royal-slider", this.galleries[galleryId])
    }

    appendInfoToGalleryConfig(/** Object */ galleryConfig) {
        /** Object */
        galleryConfig.domSliderThumbsTriggersId = `.stars-post-${galleryConfig.postId}-item:not(.stars-post-video)`

        galleryConfig.isMobileDevice = SiteInfo.isMobileDevice
        galleryConfig.isMobileVersion = SiteInfo.isMobileVersion

        return galleryConfig
    }
}
